// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CasePhoneModel {
    static getAttributeTypeMap() {
        return CasePhoneModel.attributeTypeMap;
    }
}
CasePhoneModel.discriminator = undefined;
CasePhoneModel.attributeTypeMap = [
    {
        "name": "phoneId",
        "baseName": "phoneId",
        "type": "number"
    },
    {
        "name": "phoneType",
        "baseName": "phoneType",
        "type": "CasePhoneContactInformationType"
    },
    {
        "name": "phonePurpose",
        "baseName": "phonePurpose",
        "type": "CaseContactInformationPurposeType"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "isVoicemailOptedIn",
        "baseName": "isVoicemailOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=casePhoneModel.js.map